import { z } from 'zod'

export const SelfHealingTargetsSchema = z.object({
  reviews_per_day: z.number().int().min(0).max(10000).default(20),
  analyses_per_day: z.number().int().min(0).max(10000).default(20),
}).strict()
export type SelfHealingTargets = z.infer<typeof SelfHealingTargetsSchema>
export const SelfHealingSettingsResponseSchema = z.object({
  targets: SelfHealingTargetsSchema,
  can_edit: z.boolean(),
})
